import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
export const feedStyles = stylex.create({
  header: { marginBottom: spacing.space32 },
  title: {
    margin: 0,
    fontFamily: fonts.mono,
    fontWeight: 600,
    fontSize: {
      default: fontSizes.pageTitle,
      "@media (min-width: 768px)": fontSizes.pageTitleWide,
    },
    lineHeight: 1.15,
    letterSpacing: "-0.03em",
    overflowWrap: "anywhere",
  },
  lede: {
    margin: 0,
    marginTop: spacing.space12,
    maxWidth: "62ch",
    fontSize: fontSizes.sectionTitle,
    lineHeight: 1.6,
    color: colors.muted,
  },
  feedHeight: (height: number) => ({ minHeight: height }),
  row: {
    display: "grid",
    gridTemplateColumns: "44px minmax(0, 1fr)",
    columnGap: spacing.space16,
    paddingBlock: spacing.space20,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
  },
  up: { gridColumn: 1, gridRow: 1 },
  down: {
    gridColumn: 1,
    gridRow: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rowContent: { gridColumn: 2, gridRow: "1 / 4", minWidth: 0 },
  postLink: {
    display: "block",
    color: colors.foreground,
    textDecoration: { default: "none", ":hover": "underline" },
    fontSize: fontSizes.sectionTitle,
    fontWeight: 600,
    lineHeight: 1.35,
    overflowWrap: "anywhere",
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
  },
  excerpt: {
    margin: 0,
    marginTop: spacing.space6,
    color: colors.subtle,
    fontSize: fontSizes.small,
    lineHeight: 1.5,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    overflowWrap: "anywhere",
  },
  pagination: { marginTop: spacing.space24 },
});
